import { createSyncAction } from '@bimser/core';
import { WebInterfaceAction } from 'common/entities';
import { SET_PENDING_FAST_APPROVE_DOCUMENT_COUNT_ACTION } from './actionTypes';

export const setPendingFastApproveDocumentCount = (payload: WebInterfaceAction) =>
	createSyncAction(SET_PENDING_FAST_APPROVE_DOCUMENT_COUNT_ACTION, payload);
